<script setup lang="ts">
  import { computed } from 'vue'
  import { useRoute } from 'vue-router'
  import { useUpdateRoute } from '@/functions'

  const route = useRoute()
  const { updateRoute } = useUpdateRoute()

  const filterType = computed({
    set: (saleType?: string) => updateRoute({ sale_type: saleType ?? undefined }),
    get: () => route.query.sale_type as string | undefined,
  })
</script>

<template>
  <app-select
    v-model="filterType"
    label="Tipe Jual">
    <option :value="undefined">
      Semua
    </option>
    <option value="retail">
      Retail
    </option>
    <option value="online">
      Online
    </option>
    <!-- <option value="internal">
      Internal
    </option> -->
    <!-- <option value="ecommerce">
      eCommerce
    </option> -->
  </app-select>
</template>
